const gameProfileTranslations = {
  entryCard: {
    title: 'Entry Card (Rewards Tab - Home)',
    header: 'Header',
    buttonText: 'Button Text',
    subHeader: 'Subheader',
    startTime: 'Start time',
    endTime: 'End time',
    startDate: 'Start date',
    endDate: 'End date',
    annexActionId: 'Annex Action USA ID',
    annexActionCanId: 'Annex Action CAN ID',
    backgroundColor: 'Background Color (if no image)',
    uploadImage: 'Upload BG Image (optional)',
    saveButton: 'Save Updates',
    placeholder: {
      header: '250 Points',
      buttonText: 'Get Started',
      subHeader: 'Answer Questions & Level Up',
      time: '12:00 AM',
      date: 'Select date',
      id: 'ID#',
      backgroundColor: 'hex #ffffff',
    },
    validate: {
      header: 'Please input header!',
      buttonText: 'Please input button text!',
    },
    statusSuccess: 'Entry Card updated status successfully.',
    entryCardSuccess: 'Entry card updated successfully.',
    entryCardFailed: 'The Entry card update was unsuccessful.',
    uploadError: 'Failed to upload image. Please try again.',
  },
  questionnaire: {
    title: 'Questionnaire',
    header: 'Header',
    subHeader: 'Subheader',
    thankYouHeader: 'Thank You Header',
    thankYouMessage: 'Thank You Message',
    headerColor: 'Header Color',
    subHeaderColor: 'Sub Header Color',
    saveButton: 'Save Updates',
    placeholder: {
      header: 'Title',
      subHeader: 'Title',
      thankYouHeader: 'Title',
      thankYouMessage: 'Message ',
      headerColor: '#7b7b7b',
      subHeaderColor: '#127603',
    },
    validate: {
      header: 'Please input header!',
      thankYouHeader: 'Please input thank you header!',
      thankYouMessage: 'Please input thank you message!',
    },
    questionSuccess: 'The Questionnaire updated successfully.',
    questionFailed: 'The Questionnaire update was unsuccessful.',
  },
  questions: {
    success: {
      statusSuccess: 'This question has successfully updated its status.',
      deleteSuccess: 'This question has been successfully deleted.',
      createSuccess: 'This question has been successfully created',
      updateSuccess: 'This question has been successfully updated',
    },
    error: {
      statusFailed: 'This question has failed to update its status.',
      deleteFailed: 'This question deletes the error.',
      createFailed: 'This question creates the error.',
      updateFailed: 'This question updates the error.',
    },
  },
  questionForm: {
    labels: {
      questionSet: 'Assign to Question Set',
      questionCategory: 'Question Category',
      klaviyoPropertyName: 'Klaviyo Custom Property Name',
      questionType: 'Question Type',
      subcategory: 'Subcategory',
      sectionName: 'Section Name',
      questionPrompt: 'Question Prompt',
      answerType: 'Answer Type',
      numberOfAnswers: 'Number of Answers',
      answerOptions: 'Answer Options',
      answerTitle: 'Answer',
      answerSubtitle: 'Subtitle',
      imageUrl: 'Image URL',
      imageUrlRequired: 'Image URL',
      multipleAnswersLimit: 'Multiple Answers Limit',
    },
    placeholders: {
      selectQuestionSet: 'Select',
      subcategoryInput: 'Subcategory Input',
      nameInput: 'Name Input',
      klaviyoPropertyName: 'mytm_favorite_player',
      questionPrompt: 'What Brand of Putter are You Currently Playing?',
      selectAnswerType: 'Select answer type',
      answerOption: 'Answer Option',
      title: 'Title',
      imageUrl: 'https://www.example.com/img.jpg',
      multipleAnswersLimit: 'Enter limit (max: total answers)',
    },
    buttons: {
      generate: 'GENERATE',
      uploadCsv: 'Upload .csv',
      downloadTemplate: 'Download Template',
      addAnswerOption: 'Add Answer Option',
      addRow: 'Add row',
      cancel: 'Cancel',
      addQuestion: '+ ADD QUESTION',
      updateQuestion: 'SAVE QUESTION',
    },
    validation: {
      selectCategory: 'Please select a category!',
      inputKlaviyoPropertyName: 'Please input Klaviyo Custom Property Name!',
      selectQuestionType: 'Please select a question type!',
      inputSectionName: 'Please input section name!',
      inputQuestionPrompt: 'Please input question prompt!',
      selectAnswerType: 'Please select an answer type!',
      selectQuestionSet: 'Please select a question set!',
      multipleAnswersLimitExceeded: 'Maximum value cannot exceed {{count}} (number of valid answers)',
      maxKlaviyoPropertyName: 'Max length is 64 characters',
    },
    messages: {
      answersLeftEmpty: 'Answers left empty will not save to the final list',
      atLeastAnswersRequired: 'At least {{count}} answer options are required',
      templateDownloaded: 'Template downloaded successfully',
      csvUploadedSuccessfully: 'CSV file uploaded and processed successfully',
      emptyCsvFile: 'CSV file is empty',
      invalidCsvStructure: 'CSV file structure does not match the selected answer type',
      csvParseError: 'Error parsing CSV file',
      csvAnswerTypeMismatch: 'CSV file answer type does not match the current answer type',
      multipleAnswersLimitExceeded: 'Multiple answers limit cannot exceed {{count}} (number of valid answers)',
      loadQuestionSetsFailed: 'Failed to load question sets',
    },
    answerTypes: {
      singleOneColumn: 'Simple Button - 1 Column (2-12 options)',
      singleTwoColumns: 'Simple Button - 2 Columns (10-22 options)',
      dropdownWithSearch: 'Dropdown (with search)',
      search: 'Search',
      imageTile: 'Image Tile (2-12 options)',
    },
    categories: {
      myGame: 'My Game',
      myEquipment: 'My Equipment',
      myTeams: 'My Teams',
    },
    questionTypes: {
      single: 'Single Select',
      multiple: 'Multi Select',
    },
  },
  questionSetModal: {
    title: 'Add Question Set',
    editTitle: 'Edit Question Set',
    labels: {
      name: 'Set Name',
      startTime: 'Start time',
      startDate: 'Start date',
      endTime: 'End time',
      endDate: 'End date',
      entryCardSection: 'Entry Card (Rewards Tab Home)',
      entryHeader: 'Header',
      entrySubHeader: 'Subheader',
      entryButtonText: 'Button Text',
      entryBackgroundColor: 'Background Color (if no image)',
      annexActionUsaId: 'Annex Action USA ID',
      annexActionCanId: 'Annex Action CAN ID',
      questionnaireSection: 'Questionnaire',
      questionnaireHeader: 'Header',
      questionnaireSubHeader: 'Subheader',
      questionnaireHeaderColor: 'Header Color',
      questionnaireSubHeaderColor: 'Subheader Color',
      questionnaireThankYouHeader: 'Thank You Header',
      questionnaireThankYouMessage: 'Thank You Message',
      uploadBackground: 'Upload BG Image (optional)',
    },
    placeholders: {
      name: '[Input]',
      entryHeader: '250 Points',
      entrySubHeader: 'Answer Questions & Level Up',
      entryButtonText: 'Get Started',
      entryBackgroundColor: '#HEX',
      annexActionUsaId: 'ID#',
      annexActionCanId: 'ID#',
      questionnaireHeader: 'Title',
      questionnaireSubHeader: 'Title',
      questionnaireHeaderColor: '#HEX',
      questionnaireSubHeaderColor: '#HEX',
      questionnaireThankYouHeader: 'Title',
      questionnaireThankYouMessage: 'Message',
    },
    buttons: {
      customizeEntryCard: 'CUSTOMIZE ENTRY CARD',
      customizeQuestionnaire: 'CUSTOMIZE QUESTIONNAIRE',
      cancel: 'Cancel',
      addQuestionSet: '+ ADD QUESTION SET',
      saveQuestionSet: 'SAVE QUESTION SET',
    },
    validation: {
      name: 'Please input set name!',
      startTime: 'Please select start time!',
      startDate: 'Please select start date!',
      endTime: 'Please select end time!',
      endDate: 'Please select end date!',
      scheduleRequired: 'Please select start and end date/time',
      endAfterStart: 'End date/time must be after start date/time',
      entryHeader: 'Please input entry header!',
      entryButtonText: 'Please input entry button text!',
      questionnaireHeader: 'Please input questionnaire header!',
      questionnaireThankYouHeader: 'Please input thank you header!',
      questionnaireThankYouMessage: 'Please input thank you message!',
    },
    messages: {
      loadFailed: 'Failed to load question set details',
      uploadFailed: 'Failed to upload image. Please try again.',
      created: 'Question set created successfully.',
      updated: 'Question set updated successfully.',
      createFailed: 'Failed to create question set.',
      updateFailed: 'Failed to update question set.',
      statusUpdated: 'Question set status updated successfully.',
      statusUpdateFailed: 'Failed to update question set status.',
    },
    tooltips: {
      edit: 'Edit',
      editDisabled: 'Deactivate this set to make changes.',
      copy: 'Copy',
      delete: 'Delete',
    },
    popup: {
      title: 'Confirm Action',
      okBtn: 'Confirm',
      cancelBtn: 'Cancel',
      activate: 'Are you sure you want to activate this question set?',
      deactivate: 'Are you sure you want to deactivate this question set?',
      confirmPassword: 'Please enter your password to confirm:',
    },
  },
  tableQuestions: {
    columns: {
      number: 'No.',
      question: 'Question',
      answerType: 'Answer Type',
      createDate: 'Create Date',
      scheduleDate: 'Sch. Date',
      active: 'Active',
      action: 'Action',
    },
    answerTypeLabels: {
      singleOneColumn: 'Simple Button - 1 Column',
      singleTwoColumns: 'Simple Button - 2 Columns',
      dropdownWithSearch: 'Dropdown with Search',
      search: 'Search',
      imageTile: 'Image Tile',
    },
    messages: {
      loadFailed: 'Failed to load questions',
      statusUpdated: 'Status updated successfully',
      statusUpdateFailed: 'Failed to update status',
      deleteSuccess: 'Deleted successfully',
      deleteFailed: 'Failed to delete',
      questionSetDeleteSuccess: 'Question set deleted successfully',
      questionSetDeleteFailed: 'Failed to delete question set',
      summaryLoadFailed: 'Failed to load question summary',
      updateSuccess: 'Updated successfully',
      createSuccess: 'Created successfully',
      saveFailed: 'Failed to save question',
      moveQuestionFailed: 'Failed to move question',
    },
    modal: {
      confirmDelete: 'Confirm Delete',
      okText: 'Delete',
      cancelText: 'Cancel',
      textConfirmPassword: 'Please enter your password to confirm:',
      addQuestion: 'Add Question',
      viewQuestion: 'View Question',
      editQuestion: 'Edit Question',
    },
    placeholders: {
      searchByQuestionOrSet: 'By Question or Set',
      selectAnswerType: 'Select Answer Type',
    },
    tooltips: {
      deactivateBeforeDelete: 'Deactivate this set before deleting.',
      questionSetDisabled: 'Enable the question set to change this question status.',
    },
    filterLabels: {
      search: 'Search',
      answerType: 'Answer Type',
      createdFrom: 'Created From',
      to: 'To',
    },
    buttons: {
      applyFilters: 'Apply Filters',
      clearFilters: 'Clear Filters',
      addQuestion: 'Add Question',
      addQuestionSet: 'Add Question Set',
    },
    emptyText: 'No data.',
    noQuestionsAdded: 'No questions added yet.',
  },
};

export default gameProfileTranslations;
